export default __webpack_public_path__ + "static/movistarLogo-cff33c43e715d1c1b23d94ff3600d42b.png";